import { render, staticRenderFns } from "./PostalAddressDemo.vue?vue&type=template&id=332157f5"
import script from "./PostalAddressDemo.vue?vue&type=script&lang=js"
export * from "./PostalAddressDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports